import { Button, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import styles from 'Styles/styles.module.css';

const DuplicateButton = ({
  buttonText = 'Duplicate',
  duplicateClickHandler = () => {},
  miniVersion = false,
  tooltipText = 'Click to duplicate',
}) => {
  return (
    <Tooltip
      minimal
      content={tooltipText}
      placement={'auto'}
      shouldReturnFocusOnClose={false}>
      <Button
        className={styles.primary_button_minimal}
        small={miniVersion}
        minimal
        icon={'duplicate'}
        onClick={duplicateClickHandler}>
        {!miniVersion && buttonText}
      </Button>
    </Tooltip>
  );
};

DuplicateButton.propTypes = {
  buttonText: PropTypes.string,
  duplicateClickHandler: PropTypes.func,
  miniVersion: PropTypes.bool,
  tooltipText: PropTypes.string,
};

export default DuplicateButton;
